module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAY0lEQVR42mNgQAK/Ipr+k4sZqAFGHYBs4P/OFQQxLgf8z5QcWAcMSAiAfE22z0cdMOqAYe8Aoh02pEOAKkX2qAMoSgPUqDNGHUAvB+DMrqNRMOqAUQeMOmDUAYPKAbTC6HYCAAVYAZJQuTd0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/no_activas_pluri_sin.png
// module id = X5w3
// module chunks = 0